/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateSalesOrderDto = {
    /**
     * Associated location ID
     */
    locationId?: number;
    /**
     * User ID who created the order
     */
    createdById?: string;
    /**
     * Customer profile ID
     */
    customerId?: number;
    /**
     * Order status
     */
    status?: UpdateSalesOrderDto.status;
    /**
     * Sales channel
     */
    salesChannel?: UpdateSalesOrderDto.salesChannel;
    /**
     * Priority level
     */
    priorityLevel?: UpdateSalesOrderDto.priorityLevel;
    /**
     * Has discount applied
     */
    hasDiscount?: boolean;
    /**
     * Discount scope
     */
    discountScope?: UpdateSalesOrderDto.discountScope;
    /**
     * Has partial payment
     */
    hasPartialPayment?: boolean;
    /**
     * Partial payment scope
     */
    partialPaymentScope?: UpdateSalesOrderDto.partialPaymentScope;
    /**
     * Has installments
     */
    hasInstallments?: boolean;
    /**
     * Installments frequency
     */
    installmentsFrequency?: UpdateSalesOrderDto.installmentsFrequency;
    /**
     * Subtotal before discounts
     */
    subtotal?: number;
    /**
     * Total discount amount
     */
    discountAmount?: number;
    /**
     * Subtotal before tax
     */
    subtotalBeforeTax?: number;
    /**
     * Total with tax
     */
    totalWithTax?: number;
    /**
     * Total order amount
     */
    totalAmount?: number;
    /**
     * Total extra charges amount
     */
    extraChargesTotal?: number;
    /**
     * Whether the order has extra charges
     */
    hasExtraCharges?: boolean;
    /**
     * Whether the sale includes an external manual invoice (internal tracking only)
     */
    hasInvoice?: boolean;
    /**
     * Total cost of products
     */
    totalCost?: number;
    /**
     * Profit margin percentage
     */
    profitMargin?: number;
    /**
     * Order notes
     */
    orderNotes?: string;
    /**
     * Customer notes
     */
    customerNotes?: string;
    /**
     * Estimated completion date
     */
    estimatedCompletion?: string;
    /**
     * Last payment date
     */
    lastPaymentDate?: string;
    /**
     * Next payment due date
     */
    nextPaymentDue?: string;
    /**
     * Commercial sale date (ISO 8601). Defaults to current time if omitted. Cannot be in the future.
     */
    saleDate?: string;
};
export namespace UpdateSalesOrderDto {
    /**
     * Order status
     */
    export enum status {
        DRAFT = 'DRAFT',
        CONFIRMED = 'CONFIRMED',
        PARTIAL_PAID = 'PARTIAL_PAID',
        PAID = 'PAID',
        DELIVERED = 'DELIVERED',
        CANCELLED = 'CANCELLED',
        REFUNDED = 'REFUNDED',
    }
    /**
     * Sales channel
     */
    export enum salesChannel {
        IN_STORE = 'IN_STORE',
        ONLINE = 'ONLINE',
        PHONE = 'PHONE',
        WHATSAPP = 'WHATSAPP',
    }
    /**
     * Priority level
     */
    export enum priorityLevel {
        LOW = 'LOW',
        NORMAL = 'NORMAL',
        HIGH = 'HIGH',
        URGENT = 'URGENT',
    }
    /**
     * Discount scope
     */
    export enum discountScope {
        PER_ITEM = 'PER_ITEM',
        PER_ORDER = 'PER_ORDER',
    }
    /**
     * Partial payment scope
     */
    export enum partialPaymentScope {
        PER_ITEM = 'PER_ITEM',
        PER_ORDER = 'PER_ORDER',
    }
    /**
     * Installments frequency
     */
    export enum installmentsFrequency {
        MONTHLY = 'MONTHLY',
        WEEKLY = 'WEEKLY',
        BIWEEKLY = 'BIWEEKLY',
    }
}

